export default __webpack_public_path__ + "static/media/localisation.ee32df9a.svg";